export default [
  {
    header: 'Senders & Stop List',
  },
  {
    title: 'Senders',
    route: 'senders',
    icon: 'HashIcon',
  },
  {
    title: 'Stop List',
    route: { name: 'stoplist' },
    icon: 'AlertOctagonIcon',
  },
]
